import { render, staticRenderFns } from "./SearchKeywordsPage.vue?vue&type=template&id=61ee1a6a&scoped=true"
import script from "./SearchKeywordsPage.vue?vue&type=script&lang=js"
export * from "./SearchKeywordsPage.vue?vue&type=script&lang=js"
import style0 from "./SearchKeywordsPage.vue?vue&type=style&index=0&id=61ee1a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ee1a6a",
  null
  
)

export default component.exports